__turbopack_context__.v({
  "button": "uTLZ2q_button",
  "heartIcon": "uTLZ2q_heartIcon",
});
